import { makeAutoObservable, runInAction } from 'mobx'
import { CommonAPI } from '@api/index'
import { keyBy } from '@dt/fe-utils/dist/lodash'

class MktConfig {
  constructor () {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  // 初始化标记
  isInit: boolean = false

  // 渠道&就餐方式 map
  eatTypeAndChannelMap: any = {}

  // 初始化
  async init () {
    if (this.isInit) return
    const res = await this.getEatTypeAndChannel()
    runInAction(() => {
      this.isInit = true
    })
    return res
  }

  // 获取渠道&就餐方式
  async getEatTypeAndChannel () {
    let res: any
    try {
      res = await CommonAPI.getEatTypeAndChannel()
    } catch (error) {}
    runInAction(() => {
      res && (this.eatTypeAndChannelMap = keyBy(res.result, 'key'))
    })
    return res
  }
}

export default new MktConfig()
